export default __webpack_public_path__ + "static/media/snake-game.4b911975.png";